import { useMutation, useQueryClient } from "@tanstack/vue-query";
import baseAPI from "@/api/base";

interface SendSMSPayload {
  to: string;
  body: string;
  contactId?: string;
  mediaUrls?: string[];
  conversationId?: string;
  phoneNumberId?: string;
  contactPhoneId?: string;
}

export function useSendSMS() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SendSMSPayload) => {
      const response = await baseAPI.post("/twilio/send-sms", payload);
      return response.data.data;
    },
    onSuccess: (data) => {
      // Invalidate relevant queries
      if (data.conversationId) {
        queryClient.invalidateQueries({
          queryKey: ["sms-conversation-messages", data.conversationId],
        });
      }
      if (data.contactId) {
        queryClient.invalidateQueries({
          queryKey: ["sms-conversations", data.contactId],
        });
        queryClient.invalidateQueries({
          queryKey: ["sms-messages", data.contactId],
        });
      }
    },
  });
}
